/*/// <reference types="@types/google.maps" />*/
/// <reference types="@types/google.maps" />

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, NgModel } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { LocationInfo, PageBase, T4TurboOrderService } from 't4core';
import { ContractDialog } from '../../dialogs/ContractDialog/ContractDialog';

declare var MarkerClusterer: any;

@Component({
    styleUrls: ['./map.css'],
    selector: 'map',
    templateUrl: './map.component.html',
})
export class MapComponent extends PageBase implements OnInit {

    constructor(el: ElementRef, private orderSvc: T4TurboOrderService, private fb: FormBuilder, private router : Router) {
      super(el, "TurboOrder");
    }

     // Map
    @ViewChild('gmap', {static: true}) gmapElement: any;
    @ViewChild('popupContent', { static: true}) popupElement: ElementRef;
    @ViewChild('txtMapSearch', { static: true }) gmapSearchBox: ElementRef;
    @ViewChild("txtName", { static: false }) public txtName: NgModel;
    @ViewChild("txtupdateName", { static: false }) public txtupdateName: NgModel;
    @ViewChild('selectedChain') selectedChain: MatSelect;


    private map: google.maps.Map;
    public markers = [];
    private searchPin: google.maps.marker.AdvancedMarkerElement;
    private searchBox: google.maps.places.Autocomplete;
    private infoWindow = new google.maps.InfoWindow();

    public selectedChains: string[];
    public availableChains: string[];
    public minContracts: number = 0;
    public maxContracts: number = 100;

    private clusterer: any;
    private heatmap: google.maps.visualization.HeatmapLayer;
    public expiresIn: number = 100;
    public selectedCustomer: any;
    public latLng: google.maps.LatLng;
    public Show: boolean;
    public marker;
    public latitude; longitude; lat;lng: number;
    public prospects = [];
    public name; description; updateName; updateDescription; selectedBrand; updateLatlng; updateBrand: string;
    public prospect; address: any;
    public brands: string[] = ["24Rental","Use4Free"];
    public selectedProspectId;
    public showUpdateProspect: boolean = false;
    public allSelected: boolean = false;
    private autocompleteInitialized = false;

     // View data
    private _updatingCheckboxes: boolean = false;

    // Filters
    public txtMapSearch: FormControl = new FormControl(); 

  async ngOnInit() {

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        var mapProp = {
            center: new google.maps.LatLng(60.5793, 14.8143),
            zoom: 6,
            mapId: '2bfb441deccab4d5b8508848',
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

        // Add new location marker
        this.map.addListener("click", (e) => {
          this.addMarker(e.latLng);
          this.latLng = e.latLng;
          this.GetAddress(this.latLng.toJSON().lat, this.latLng.toJSON().lng);
          this.Show = true;
        });

        this.showMarkers();

      this.availableChains = await this.orderSvc.GetChains();
      this.selectedChains = [ "0" ];

      this.update();
  }

  public onSearchFocus() {
    if (this.autocompleteInitialized) return;
    this.autocompleteInitialized = true;
    this.initPlacesAutocomplete();
  }

  private initPlacesAutocomplete() {
    if (!this.gmapSearchBox?.nativeElement) return;
    this.searchBox = new google.maps.places.Autocomplete(this.gmapSearchBox.nativeElement, { types: ["(cities)"], componentRestrictions: { country: ['se', 'da', 'no'] }, fields: ['geometry'] });
    this.searchBox.addListener("place_changed", () => {

      //get the place result
      let place: google.maps.places.PlaceResult = this.searchBox.getPlace();

      //verify result
      if (this.searchPin) this.searchPin.map = null;
      if (place.geometry === undefined || place.geometry === null) {
        return;
      }

      // Add pin
      this.searchPin = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: place.geometry.location,

        zIndex: 2000
      });

      //set latitude, longitude and zoom
      this.map.panTo(place.geometry.location);
      this.map.setZoom(10);
    });
  }

    // Add new location marker
    public addMarker(position) {
      
        if (this.marker) {
          this.marker.map = null;
        }
     
      this.marker = new google.maps.marker.AdvancedMarkerElement({
                        position,
                        gmpDraggable: true,
                        map: this.map,
        });

      this.markers.push(this.marker);

      /*this.marker.setAnimation(google.maps.Animation.DROP);*/
      this.infoWindow.setContent(this.marker.position.toString());
      this.infoWindow.open(this.map, this.marker);
      this.showUpdateProspect = false;
    }

    // Get address from latitude and longtitude 
    public GetAddress(lat,lng) {
      
      var Newlatlng = new google.maps.LatLng(lat,lng);
      var geocoder = geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'latLng': Newlatlng }, (results, status)=> {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[1]) {
            this.address = results[1].formatted_address;
            /*alert("Location: " + results[1].formatted_address); */
          }
          else {
            alert("No results found");
          }
        }
      });
      
    }
    
    // Create new prospect
    public async saveNewProspect() {

      if (this.txtName.invalid) return;
      if (this.selectedBrand == null) {
        alert("Please select a brand!");
        return;
      }
    
        this.latitude = this.marker.position.lat();
        this.longitude = this.marker.position.lng();
     
      this.prospects = await this.orderSvc.SaveNewProspect(null, this.latitude, this.longitude, this.name, this.description, this.selectedBrand);
      if (this.prospects != null) {
        alert('Prospect successfully created!')
        this.reloadCurrentRoute();
      }
      return this.prospects;
    }

    // Update a prospect
     public async updateProspect() {
        
          if (this.txtupdateName.invalid) return;
          if (this.updateBrand == null) {
            alert("Please select a brand!");
            return;
          }
      
          this.prospects = await this.orderSvc.SaveNewProspect(this.selectedProspectId, this.lat, this.lng, this.updateName, this.updateDescription, this.updateBrand);
          if (this.prospects != null) {
            alert('Prospect successfully updated!');
          }
          this.showUpdateProspect = false;
          this.reloadCurrentRoute();
          return this.prospects;
     }
  
    // show all markers
    public async showMarkers() {
      var pro = await this.orderSvc.GetAllProspects();
        
      for (var i = 0; i < pro.length; i++) {
        this.addProspectMarker(pro[i]);
      }
    }

  // add a marker info
    //old code
    //private addProspectMarker(item) {
    //  var marker = new google.maps.Marker({
    //    position: new google.maps.LatLng(item.Latitude, item.Longtitude),
    //    map: this.map,
    //    icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
    //    title: "Name : " + item.Name + " /  Description :  " + item.Description + " /  Brand "+ item.Brand
    //  });
    //  marker.addListener('click', e => {
    //    this.selectedProspectId = item.ID;
    //    this.showUpdateProspect = true;
    //    this.getProspect(this.selectedProspectId);
    //    this.infoWindow.setContent("Name :" + item.Name + "/ Description : " + item.Description + "/ Brand :" + item.Brand);
    //    this.infoWindow.open(this.map, marker);
    //    this.Show = false;
    //    if (this.marker) {
    //      this.marker.setMap(null);
    //    }
    //  })
  //}

  //new code
  private addProspectMarker(item) {
    const iconImg = document.createElement('img');
    iconImg.src = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
    iconImg.style.width = '32px';
    iconImg.style.height = '32px';

    const marker:any = new google.maps.marker.AdvancedMarkerElement({
      map: this.map,
      position: new google.maps.LatLng(item.Latitude, item.Longtitude),
      title: "Name : " + item.Name + " /  Description :  " + item.Description + " /  Brand " + item.Brand,
      content: iconImg
    });

    marker.addEventListener('gmp-click', () => {
      this.selectedProspectId = item.ID;
      this.showUpdateProspect = true;
      this.getProspect(this.selectedProspectId);
      this.infoWindow.setContent("Name :" + item.Name + "/ Description : " + item.Description + "/ Brand :" + item.Brand);
      this.infoWindow.open(this.map, marker);
      this.Show = false;

      if (this.marker) {
        this.marker.map = null;
      }
    });
  }

    // reload the map
    reloadCurrentRoute() {
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
          
        });
    }

    // set blue colour to 24Rental markers
    private setMarkerImage(marker: any, location: any) {
          if (location.Chain == '24Rental') {
            marker.setIcon("http://maps.google.com/mapfiles/ms/icons/blue-dot.png");
          }
          else
          {
            marker.setIcon("http://maps.google.com/mapfiles/ms/icons/red-dot.png");
          }
    }

    // Get a prospect(id)
    public async getProspect(id: number) {
      var prospect = await this.orderSvc.GetProspect(id);
      
      this.lat = prospect.Latitude;
      this.lng = prospect.Longtitude;
      this.updateLatlng = this.lat + " , " + this.lng;
      this.GetAddress(this.lat, this.lng);
      this.updateName = prospect.Name;
      this.updateBrand = prospect.Brand;
      this.updateDescription = prospect.Description;
    }

    // delete prospect
    public async deleteProspect() {
         
      var pro = await this.orderSvc.DeleteProspect(this.selectedProspectId);
      console.log(pro);
         if (pro == null) {
            alert('Prospect successfully Deleted!')
         }
      this.reloadCurrentRoute();
    }


    public async update() {
        var token = this.UI.beginLoading("Turbo.OneWay.Map.msgLoadingLocationData", "Loading location data", null);

        var existing = this.markers;
        for (var i = 0; i < existing.length; i++) {
          existing[i].marker.setMap(null);
        }
        this.markers = [];

        var chains = "";

        if (this.selectedChains.indexOf("0") >= 0)

        this.availableChains.map(x => chains += x + ",");
            else
        this.selectedChains.map(x => chains += x + ",");


        var x = await this.orderSvc.GetContractMapOverview(chains, this.minContracts, this.maxContracts, this.expiresIn);
              var data = x;
              var markers = [];

              var i = 0;
              for (var item of x) {
                      this.addLocation(item, 50);
                  i++;
              }

        this.addHeatmap(x);

        //if (this.clusterer) this.clusterer.setMap(null);
        //    this.clusterer = new MarkerClusterer(this.map, this.markers.map(x => x.marker), { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });

        this.UI.loaderCompleted(token);
    }

    private queryClientFilter(location: LocationInfo): boolean {
        if (!location) return true;

        return true;
    }
      // 
      // CreateLocation(){ GetLocation(x,y) , CreateMarker(x,y) }
      // UpdateLocation(){ open add name + adress + trailers }

    private addLocation(item: any, delay: number) {
        

            var marker:any = new google.maps.marker.AdvancedMarkerElement({
                //map: this.map,
                position: new google.maps.LatLng(item.Latitude, item.Longitude),
                /*icon:"",*/
        
                title: item.Name + ", " + item.Address,
                //animation: google.maps.Animation.DROP,
                zIndex: 2000,
            });


            this.setMarkerImage(marker, item);

            marker.addListener('click', () => {
                this.infoWindow.setContent(`<h5>${item.Name}</h5><span>${item.Address}<br/>${item.City}<br/><br/>${item.Contracts.length} trailers</span>`);
                this.infoWindow.open(this.map, marker);
                this.selectedCustomer = item;
            });

            this.markers.push({ locationId: item.Id, location: item, marker: marker });

            marker.map = this.map;

         return marker
    }

    
    // Map functions
    private addHeatmap(data: any[]) {
        var heatmapData = [];

        for (var i of data) {
            heatmapData.push({ location: new google.maps.LatLng(i.Latitude, i.Longitude), weight: i.Contracts.length });
      }

      if (this.heatmap) this.heatmap.setMap(null);

        this.heatmap = new google.maps.visualization.HeatmapLayer({
            data: heatmapData,
            dissipating: false,
            radius: 5
        });

        this.heatmap.setMap(this.map);
    }
    // End Map functions

    public openContractDialog(contractId: number, vehicleId: string) {
      if (vehicleId)
        ContractDialog.open(this.Dialog, vehicleId);
      else
        ContractDialog.openContract(this.Dialog, contractId);
    }

    // toggel chain selection
    public toggleAllSelection() {

      this.allSelected = !this.allSelected;  // to control select or unselect

      if (this.allSelected) {
        this.selectedChain.options.forEach((item: MatOption) => item.select());
      }
      else
      {
        this.selectedChain.options.forEach((item: MatOption) => item.deselect());
      }

      this.selectedChain.close();
  }
  
}
